// extracted by mini-css-extract-plugin
export default {"input":"P9-z","button":"Q9-z","selected":"R9-z","unavailable":"S9-z","oos":"T9-z","image":"U9-z","paperCutDisabledOverlay":"V9-z"};